import React, { useState, useEffect, createContext, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { fetchCheckoutDisclaimer, CheckoutDisclaimer } from "../../../utils/checkoutDisclaimer";

import { Badge, Modal, ModalHeader, Card, CardBody, CardTitle, Col, Collapse, Row, CardImg, Button, Alert, Label, Input, ModalBody } from "reactstrap";
import defaultUserImg from "../../../assets/images/defaultuserimgdark.png"
import { parse, isBefore, subHours } from 'date-fns'; // optional utils
//Import Breadcrumb
// import Breadcrumbs from "../../../Components/Common/Breadcrumb";
import { subscribeToTokenRefresh } from "../../../helpers/Refreshfile";
import classnames from "classnames";
import axios from "axios"
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { CustomReactComponents } from "../others/Custom React Components/CustomReactComponents";
// import Navbar from "Layouts/HorizontalLayout/Navbar";
import { User, Clock, DollarSign, Calendar, MapPin, Globe, Star, Shield, Building2, GraduationCap, Award, Briefcase, Languages, Wrench, Users, FileText, Mail, Phone, ExternalLink, Linkedin, Facebook, Twitter, Instagram, Youtube, BookOpen } from 'lucide-react';

import { useDomainContext } from 'pages/custom/DomainContext';

import { DateTime } from 'luxon';


const Explist = (props: any) => {
  const navigate = useNavigate();




  const [openColl, setOpenColl] = useState<any>(true);
  const toggleLeftmenu = () => setOpenColl(!openColl);

  const { domains, setDomains, selectedSubdomain, setSelectedSubdomain, myParams, setMyParams, collapsed, setCollapsed } = useDomainContext();
  // const [domains, setDomains] = useState<any>([{}]);  //  {id:0, name:"d1", iconclass:"bx bx-grid", navsubdomains:[{id:0, name:"s1", iconclass:"bx bx-grid", navcontents:[{id:0, itype:"na"}]}]}
  // const [selectedSubdomain, setSelectedSubdomain] = useState<any>(null);  
  // const [collapsed, setCollapsed] = useState({});










  const [alertMsgg, setAlertMsgg] = useState<any>({ open: false, type: "success", content: 'Messages here.', time: '2500', showCartLink: false });
  const handleAlertMsggClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") { return; }
    setAlertMsgg({ ...alertMsgg, open: false })
  };
  const [showloader, setshowloader] = useState(true);

  // Checkout Disclaimer
  const [checkoutDisclaimer, setCheckoutDisclaimer] = useState<CheckoutDisclaimer | null>(null);
  const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);
  const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);
  const [pendingCheckoutAction, setPendingCheckoutAction] = useState<(() => void) | null>(null);

  useEffect(() => {
    fetchCheckoutDisclaimer().then(setCheckoutDisclaimer);
  }, []);

  const [cartLength, setCartLength] = useState(0);
  useEffect(() => {
    setCartLength(parseInt(localStorage.getItem("cart_length") || "0"));
    const updateCartLength = () => {
      setCartLength(parseInt(localStorage.getItem("cart_length") || "0"));
    };
    window.addEventListener("cartLengthUpdated", updateCartLength);
    window.addEventListener("focus", updateCartLength);
    return () => {
      window.removeEventListener("cartLengthUpdated", updateCartLength);
      window.removeEventListener("focus", updateCartLength);
    };
  }, []);


  //meta title
  document.title = "BizServe";
  const [experts, setexperts] = useState<any>([]);
  const [orgExperts, setOrgExperts] = useState<any>([]);
  const [packages, setPackages] = useState<any>([]);

  const [scat, setscat] = React.useState('All');
  const [subcat, setsubcat] = React.useState('All');
  const [budget, setbudget] = React.useState('All');
  const [avail, setavail] = React.useState<any>('All');
  const [budget_opts, updatebudget] = React.useState([]);
  interface SubCategory { id: number; title: string; }
  const [allcats, setallcats] = React.useState<any>([]);
  const [subcat_opts, updatesubcatsopts] = React.useState<SubCategory[]>([]);
  const [cat_opts, updatecatsopts] = React.useState<any>([]);
  const [experttimezone, setExpertTimezone] = useState<any>([]);

  // var : { [key: string]: SubCategory[] } = {}

  const [cstPack, setCstPack] = useState(() => {
    const cstPackRaw = localStorage.getItem('cstpack');
    return cstPackRaw ? JSON.parse(cstPackRaw) : {};
  });
  // FREE_PLATFORM_MODE: Platform is free. To restore: localStorage.getItem('userole_') === "cst" && !cstPack?.active;
  const isInactiveCst = false;

  const updatesubdomaincontent = (did: any, sid: any, rdomains: any = null) => {
    setsubcat('All'); setbudget('All'); setavail('All');
    if ((did && sid) || rdomains) {

      var sdom: any = null
      var rdom: any = null
      var ncon: any = null
      if (rdomains && domains?.length) {

        try {
          const pathParts = window.location.pathname.split('/').filter(Boolean);
          if (pathParts.length >= 2) {
            const dIdx = parseInt(pathParts[0], 10) - 1;
            const sIdx = parseInt(pathParts[1], 10) - 1;
            if (!isNaN(dIdx) && !isNaN(sIdx) && rdomains[dIdx] && rdomains[dIdx].navsubdomains?.[sIdx]) {
              rdom = rdomains[dIdx];
              sdom = rdom.navsubdomains[sIdx];
            }
          }

          if (!rdom || !sdom) {
            for (const domain of rdomains) {
              if (domain.navroles?.includes(localStorage.getItem('userole_') || "") || localStorage.getItem('userole_') == "adm") {
                for (const subdomain of domain.navsubdomains) {
                  if (subdomain.navroles?.includes(localStorage.getItem('userole_') || "") || localStorage.getItem('userole_') == "adm") {
                    sdom = subdomain;
                    rdom = domain;
                    break;
                  }
                }
                if (rdom) break;
              }
            }
          }
          setSelectedSubdomain(sdom);
          handleAccordionToggle(rdom ? rdom.id : rdomains[0]?.id)
        } catch { console.log("____________________Unable to open default subdomain") }
      }
      else {

        let ddom = domains.filter((dom: any) => (dom.id == did))[0];

        sdom = ddom?.navsubdomains.filter((subdom: any) => (subdom.id == sid))[0];

        setSelectedSubdomain(sdom);
      }
      ncon = sdom?.navcontents.map((ncont: any) => (ncont.category?.id)).filter((a: any) => (a ? true : false))

      if (ncon?.length > 0) { updatesubcatsopts(allcats[ncon[0]]); console.log("updatesubcatsopts(allcats[ncon[0]])", allcats[ncon[0]]) }

    } else {

      // updatesubcatsopts( Object.values(allcats).flat() as SubCategory[] )
      updatesubcatsopts([])
      setSelectedSubdomain(null);
    }
  }

  useEffect(() => {
    updatesubdomaincontent(myParams['did'], myParams['sid'], myParams['rdomains'])
  }, [myParams])

  useEffect(() => {
    const handlePopState = () => {
      if (domains && domains.length > 0 && domains[0].id) {
        const pathParts = window.location.pathname.split('/').filter(Boolean);
        if (pathParts.length >= 2) {
          const dIdx = parseInt(pathParts[0], 10) - 1;
          const sIdx = parseInt(pathParts[1], 10) - 1;
          const domain = domains[dIdx];
          const subdomain = domain?.navsubdomains?.[sIdx];
          if (domain && subdomain) {
            setMyParams({ did: domain.id, sid: subdomain.id, rdomains: null });
            return;
          }
        }
        setMyParams({ did: 0, sid: 0, rdomains: null });
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [domains]);

  const gettheexperts = (cat: any) => {
    console.log("experts.filter((exp:any)=>(exp.catid == cat.id))____", experts.filter((exp: any) => (exp.catid == cat.id)), experts, cat, cat.id)
    return experts.filter((exp: any) => (exp.catid == cat.id))
  }

  const fetch_experts = async () => {
    try {
      setshowloader(true)
      const response = await axios.post(`accounts/get_experts`, { withCredentials: true, headers: { 'Content-Type': 'application/json' } });
      if (response.status === "SENT") {
        setDomains(response.domains)
        let collapse = {}
        response.domains.forEach((domain: any) => {
          collapse[`domain_${domain.id}`] = false
          if (domain.navsubdomains) {
            domain.navsubdomains.forEach((subdomain: any) => {
              collapse[`subdomain_${subdomain.id}`] = false
            });
          }
        })
        setCollapsed(collapse)
        updatesubdomaincontent(null, null, response.domains)

        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);

        const fetchedExperts = response.exps.map((item: any) => ({
          id: item.id,
          image: (item.user.profile_pic) ? item.user.profile_pic : defaultUserImg,
          title: `${item.user.get_full_name}`,
          location: 'NOT IN USE AT THE MOMENT',
          price: `${item.price_range.min}-$${item.price_range.max}`,
          allpacks: item.packs,
          allpacksprices: item.packs.map((a: any) => ({ price: a.price, session: a.session_mins })),
          url: 'NOT IN USE AT THE MOMENT',
          rating: item.ratings,
          policy_time: item.policy_time,
          category: `${item.basic_cat[0]} (${item.basic_cat[1]})`,
          catid: item.category.id,
          subcatid: item.subcategory.id,
          availability: item.current_avl,
          expert_local_time: item.server_local_time.expert_local_time,
          timezone: item.timezone,
          country_code: item.country_code,
          bookingavails: Object.keys(item.availabilty).reduce((acc: any, date: string) => {
            const todayString = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;
            if (date >= todayString) {
              acc[date] = item.availabilty[date];
            }
            return acc;
          }, {}),
          // Store full expert object for detailed view
          fullExpertData: item
        }));
        const expertTimezones = response.exps.map((item: any) => item.timezone);
        setExpertTimezone(expertTimezones)
        setexperts(fetchedExperts);
        setOrgExperts(fetchedExperts);
        updatebudget(response.budget);
        //   setallcats(response.cats.reduce((acc: { [key: string]: SubCategory[] }, cat: any) => {
        //     acc[cat.id] = cat.subcats.map((subcat: any) => ({id: subcat.id, title: subcat.name}))

        // }));
        setallcats(response.cats.reduce((acc: { [key: string]: SubCategory[] }, cat: any) => {
          acc[cat.id] = cat.subcats.map((subcat: any) => ({ id: subcat.id, title: subcat.name }));
          return acc;
        }, {}));
        setexperts(fetchedExperts);
        setOrgExperts(fetchedExperts);
        updatebudget(response.budget);
        setallcats(response.cats.reduce((acc: { [key: string]: SubCategory[] }, cat: any) => {
          acc[cat.id] = cat.subcats.map((subcat: any) => ({ id: subcat.id, title: subcat.name }));
          return acc;
        }, {}))
        updatecatsopts(response.cats.map((cat: any) => ({ id: cat.id, title: cat.name })));
        updatesubcatsopts(response.cats.flatMap((cat: any) => cat.subcats.map((subcat: any) => ({ id: subcat.id, title: subcat.name }))));

        const packageData = response.packs.map((item: any) => ({
          id: item.id,
          name: item.name,
          price: item.price,
          description: item.description,
          features: item.features,
          mpopular: item.mpopular,
          trial_days: item.trial_days,
          // features: item.features.feature
        }));
        setPackages(packageData);
        setTimeout(() => { setshowloader(false) }, 1200)
      }
    } catch (error: any) {
      console.log('REACHED IN CATCH')
      if (error.response) {
        if ([401, 422].includes(error.response.status)) {
          console.log('Error in stripe payment')
          setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
        }
        else if (error.response.status === 403) {
          console.log('Error stripe payment')
          setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
          setTimeout(() => { window.location.href = "/logout" }, 2000)
        } else {
          console.log('An error occurred')
          setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
        }
      } else {
        console.log('An error occurred')
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
      }
      setshowloader(false)
    }
  };

  const handleAccordionToggle = (did: any) => {
    const newCollapsed = {};
    domains.forEach(d => { newCollapsed[`domain_${d.id}`] = false; });
    newCollapsed[`domain_${did}`] = !collapsed[`domain_${did}`];
    setCollapsed(newCollapsed);
  }

  useEffect(() => {
    if (orgExperts.length > 0) {
      var filtered = orgExperts

      filtered = filtered.filter((exp: any) => ((
        ((avail == "All") ? true : ((avail == "Available") == exp.availability)) &&
        ((subcat == exp.subcatid) || (subcat == "All")) &&
        ((scat == exp.catid) || (scat == "All"))
      )))

      // filtering by budget
      if (budget && (budget != "All")) {
        let bd: any = budget.match(/\d+/g);
        let minbd = parseInt((bd.length == 1) ? 0 : bd[0])
        let maxbd = parseInt((bd.length == 1) ? bd[0] : bd[1])

        const checkinclusion = (ilist: any) => {
          let a = false
          ilist.forEach((i: any) => { if (minbd <= i && i <= maxbd) { a = true } })
          return a
        };
        var filtered = filtered.filter((exp: any) => (checkinclusion(exp.allpacksprices)))
      }

      setexperts(filtered)
    }
  }, [budget, avail, subcat, scat]);

  const [modal_center, setmodal_center] = useState(false);
  function booknow() { //SUBSCRIPTION MODAL FUNCTION
    setmodal_center(!modal_center);
    document.body.classList.add("no_padding");
  }

  const [selectedPricePack, setSelectedPricePack] = useState<any>(null);
  const [selectedSlot, setSelectedSlot] = useState<any>(null);
  const [selectedPurpose, setSelectedPurpose] = useState<any>(null);
  const [selectedExpert, setSelectedExpert] = useState<any>(null);
  const [selectedBookingDate, setSelectedBookingDate] = useState<any>();
  const [modal_center_form, setmodal_center_form] = useState(false);
  const [policy_time, setpolicy_time] = useState<string[]>([]);
  const [policy_screen_error, setpolicy_screen_error] = useState(false);
  const [policyendMessage, setpolicyendMessage] = useState<string>('');

  const [newpolicy, setpolicy] = useState<any>([]);
  const [newtime, settime] = useState<any>();

  const checkCancellationWindow = () => {

    if (!selectedBookingDate || !selectedPricePack || !selectedSlot || !policy_time) {
      console.log("❌ Missing required info");
      return;
    }

    const expertZone = selectedExpert.timezone;
    console.log('expertZone----', expertZone)

    const bookingTimeStr = `${selectedBookingDate} ${selectedSlot}`;
    const fullBookingTime = DateTime.fromFormat(bookingTimeStr, 'yyyy-MM-dd h:mm a', {
      zone: expertZone
    });

    if (!fullBookingTime.isValid) {
      console.error("❌ Invalid booking time format:", fullBookingTime.invalidExplanation);
      return;
    }

    const policyHours = parseInt(policy_time.toString());
    setpolicy(policyHours);

    const cutoffTime = fullBookingTime.minus({ hours: policyHours });
    const formattedCutoffTime = cutoffTime.toLocaleString(DateTime.DATETIME_MED);
    settime(formattedCutoffTime);

    const now = DateTime.now().setZone(expertZone);
    const diffMs = cutoffTime.toMillis() - now.toMillis();
    const expiryFromNow = now.plus({ hours: policyHours });

    // const formattedNow = now.toLocaleString(DateTime.DATETIME_MED);
    // const formattedFuture = expiryFromNow.toLocaleString(DateTime.DATETIME_MED);


    // const fullBookingTime = parse(`${selectedBookingDate} ${selectedSlot}`, "yyyy-MM-dd hh:mm a", new Date());
    // const policyHours = parseInt(policy_time.toString());
    // setpolicy(policyHours)
    // const cutoffTime = new Date(fullBookingTime.getTime() - policyHours * 60 * 60 * 1000);

    // const formattedCutoffTime = cutoffTime.toLocaleString('en-US', {
    //   month: 'long',
    //   day: 'numeric',
    //   hour: 'numeric',
    //   minute: '2-digit',
    //   hour12: true
    // });

    // settime(formattedCutoffTime);


    // const now = new Date();
    // const diffMs = cutoffTime.getTime() - now.getTime();
    // const expiryFromNow = new Date(now.getTime() + policyHours * 60 * 60 * 1000);
    // const options: Intl.DateTimeFormatOptions = {
    //   day: '2-digit',
    //   year: 'numeric',
    //   hour: 'numeric',
    //   minute: '2-digit',

    //   month: 'long',
    //   hour12: true
    // };

    // const formattedNow = now.toLocaleString('en-IN', options);
    // console.log('formattedNow----', formattedNow)
    // const formattedFuture = expiryFromNow.toLocaleString('en-IN', options);
    // console.log("cutoffTime----", cutoffTime)
    // console.log("diffMs-----", diffMs)
    // console.log("Policy Time:", policyHours);
    // console.log("Current Time:", formattedNow);
    // console.log("Current Time----:", formattedFuture);
    if (diffMs > 0) {
      const message = `
      You can cancel this booking and receive a full refund up to ${policyHours} hour(s) before the event.

      \n Cancellation deadline: ${formattedCutoffTime}
      `;
      setpolicy_screen_error(false);
      setpolicyendMessage(message);
      console.log(message);
    } else {
      setpolicy_screen_error(true)
      setpolicyendMessage(``);
    }
  };



  useEffect(() => {
    if (selectedBookingDate && selectedSlot && selectedPricePack && policy_time) {
      checkCancellationWindow();
    }
  }, [selectedBookingDate, selectedSlot, selectedPricePack, policy_time]);


  function booknowform(expert: any = null) { //BOOKING MODAL FUNCTION
    console.log("selected expert__________", expert)
    setSelectedExpert(expert)
    setpolicy_time(expert?.policy_time)
    setSelectedPurpose(null)
    setmodal_center_form(!modal_center_form);
    document.body.classList.add("no_padding");
  }

  // Fetch customer profile to refresh subscription status
  const fetchCustomerProfile = async () => {
    try {
      const response = await axios.post('accounts/get_customer', {}, { withCredentials: true });
      if (response.status === "SENT" && response.userprofile?.cstpack) {
        // Update localStorage with fresh subscription data
        localStorage.setItem('cstpack', JSON.stringify(response.userprofile.cstpack));
        // Update state to trigger re-render
        setCstPack(response.userprofile.cstpack);
        console.log('Customer profile refreshed, subscription status updated');
      }
    } catch (error: any) {
      console.error("Error fetching customer profile:", error);
      // Don't show error to user, just log it
    }
  };

  React.useEffect(() => {
    fetch_experts();
    // Fetch customer profile on mount to refresh subscription status
    if (localStorage.getItem('userole_') === "cst") {
      fetchCustomerProfile();
    }
    subscribeToTokenRefresh(() => {
      console.log("🔁 Token refreshed. Re-fetching experts...");
      fetch_experts();
    });
    // Listen for profile refresh events
    window.addEventListener("refreshProfile", fetchCustomerProfile);
    return () => {
      window.removeEventListener("refreshProfile", fetchCustomerProfile);
    };
  }, []);



  //  Select Portal Subscription Start____________________________________________________________

  const bookSubscription = (packId: number) => {
    withDisclaimerCheck(() => handleStripeclick(packId));
  };
  const [isSubmitting, setIsSubmitting] = useState(false);  // State for tracking submission

  const withDisclaimerCheck = (action: () => void) => {
    if (checkoutDisclaimer) {
      setDisclaimerAccepted(false);
      setPendingCheckoutAction(() => action);
      setShowDisclaimerModal(true);
    } else {
      action();
    }
  };

  const handleStripeclick = async (packId: number) => {
    const user_role = localStorage.getItem('userole_')

    console.log('🔄 Starting subscription checkout for pack:', packId, 'user role:', user_role);

    if (isSubmitting) return;
    setIsSubmitting(true);
    setshowloader(true)

    // Add a timeout to prevent infinite loading
    const timeoutId = setTimeout(() => {
      console.log('⏰ Request timeout - stopping loader');
      setshowloader(false);
      setIsSubmitting(false);
      setAlertMsgg({ ...alertMsgg, open: true, content: "Request timed out. Please try again.", type: "error" });
    }, 30000); // 30 second timeout

    try {
      const subPayload: any = { user_selected_pack: packId, user_role: user_role };
      if (checkoutDisclaimer) subPayload.disclaimer_version_id = checkoutDisclaimer.id;
      const response = await axios.post('payments/create_subscription_checkout', subPayload, {
        withCredentials: true, headers: {
          "Content-Type": "application/json",
        },
      });

      clearTimeout(timeoutId); // Clear timeout on success
      console.log('📡 Subscription checkout response:', response);

      if (response.status === 'chekout_stripe' && response.success_url) {
        console.log('Success stripe payment')
        setAlertMsgg({ ...alertMsgg, open: true, content: `Redirecting you for subscription payment.`, type: "success" })
        setTimeout(() => { setAlertMsgg(prev => ({ ...prev, open: false })); }, 3000);
        setTimeout(() => {
          window.location.href = response.success_url;
          setshowloader(false)
        }, 3500);
      } else if (response.status === 'subscription_updated') {
        console.log('Subscription updated')
        setAlertMsgg({ ...alertMsgg, open: true, content: `Your subscription has been successfully updated.`, type: "success" })
        setTimeout(() => { setAlertMsgg(prev => ({ ...prev, open: false })); }, 3000);
        setTimeout(() => {
          window.location.href = "/";
          setshowloader(false)
        }, 3500);
      } else {
        console.log('Unexpected response format:', response);
        setAlertMsgg({ ...alertMsgg, open: true, content: "Unexpected response from server. Please try again.", type: "error" });
        setshowloader(false)
      }
      // alert("User status changed successfully!");
    } catch (error: any) {
      clearTimeout(timeoutId); // Clear timeout on error
      if (error.response) {
        if ([401, 422].includes(error.response.status)) {
          console.log('Error in stripe payment')
          setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
        }
        else if (error.response.status === 403) {
          console.log('Error stripe payment')
          setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
          setTimeout(() => { window.location.href = "/logout" }, 2000)
        } else {
          console.log('An error occurred')
          setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
        }
      } else {
        console.log('An error occurred')
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
      }
      setshowloader(false)
    } finally {
      clearTimeout(timeoutId); // Ensure timeout is cleared
      setIsSubmitting(false); // Re-enable button
    }
  }

  // checkout function
  async function booktheexpert() {
    let data = { user_info: localStorage.getItem('userinfo_'), seltime: selectedSlot, price: selectedPricePack, expid: selectedExpert.id, seldate: selectedBookingDate ? new Date(`${selectedBookingDate}T12:00:00`).toISOString() : null, purpose: selectedPurpose };

    let vars: any = []
    if (!(data['seldate'])) { vars.push('Booking date') };
    if (!(data['price'])) { vars.push('Package or Duration') };
    if (!(data['seltime'])) { vars.push('Booking slot'); }
    if (!(data['purpose'])) { vars.push('Booking purpose') }
    if (vars.length) {
      // alert(`Please select ${vars.join(", ")} !`)
      setAlertMsgg({ ...alertMsgg, open: true, content: `Please select ${vars.join(", ")} !`, type: "error" })
      setTimeout(() => {
        setAlertMsgg(prev => ({ ...prev, open: false }));
      }, 4000);
      return
    }



    // const openloader = document.querySelector('.loaderWeb') as HTMLElement | null;
    // if (openloader) {openloader.style.display = 'flex';}      

    // Add a timeout to prevent infinite loading
    const timeoutId = setTimeout(() => {
      console.log('⏰ Expert booking request timeout - stopping loader');
      setshowloader(false);
      setAlertMsgg({ ...alertMsgg, open: true, content: "Request timed out. Please try again.", type: "error" });
    }, 30000); // 30 second timeout

    try {
      setshowloader(true)
      console.log("Data_______________", data)
      const expertPayload: any = { ...data };
      if (checkoutDisclaimer) expertPayload.disclaimer_version_id = checkoutDisclaimer.id;
      const response = await axios.post('payments/create_expert_checkout', expertPayload, { withCredentials: true, headers: { "Content-Type": "application/json", }, });

      clearTimeout(timeoutId); // Clear timeout on success

      if (response.status === 'chekout_stripe' && response.success_url) {
        window.location.href = response.success_url
        setshowloader(false)
      } else {
        console.log('Unexpected response format:', response);
        setAlertMsgg({ ...alertMsgg, open: true, content: "Unexpected response from server. Please try again.", type: "error" });
        setshowloader(false)
      }
    } catch (error: any) {
      clearTimeout(timeoutId); // Clear timeout on error
      if (error.response) {
        if ([401, 422].includes(error.response.status)) {
          console.log('Error in stripe payment')
          setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
        }
        else if (error.response.status === 403) {
          console.log('Error stripe payment')
          setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
          setTimeout(() => { window.location.href = "/logout" }, 2000)
        } else {
          console.log('An error occurred')
          setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
        }
      } else {
        console.log('An error occurred')
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
      }
      setshowloader(false)
    } finally {
      clearTimeout(timeoutId); // Ensure timeout is cleared
      const closeloader = document.querySelector('.loaderWeb') as HTMLElement | null;
      if (closeloader) { closeloader.style.display = 'none'; }
      setIsSubmitting(false);
    }
  }

  const [selectedSessionMins, setSelectedSessionMins] = useState<number | null>(null);
  const handleSessionMins = (pack: any) => {
    setSelectedSessionMins(pack.session_mins);
  };

  const [modal_expert_details, setmodal_expert_details] = useState(false);
  const [selectedExpertDetails, setSelectedExpertDetails] = useState<any>(null);
  const [loadingExpertDetails, setLoadingExpertDetails] = useState(false);
  const [fullExpertProfile, setFullExpertProfile] = useState<any>(null);

  const fetchFullExpertProfile = async (expertId: string) => {
    try {
      setLoadingExpertDetails(true);
      // Fetch full expert profile details using get_experts with expid and full_details
      const response = await axios.post(`/accounts/get_experts`,
        { expid: expertId, full_details: true },
        { withCredentials: true, headers: { 'Content-Type': 'application/json' } }
      );
      if (response.status === 'SENT' && response.exps && response.exps.length > 0) {
        setFullExpertProfile(response.exps[0]);
      } else {
        setFullExpertProfile(null);
      }
    } catch (error: any) {
      console.error("Error fetching expert profile:", error);
      // If API fails, we'll use the basic expert data from fullExpertData
      // The modal will fall back to using selectedExpertDetails.fullExpertData
      setFullExpertProfile(null);
    } finally {
      setLoadingExpertDetails(false);
    }
  };

  function toggleExpertDetails(expert: any = null) {
    if (expert) {
      setSelectedExpertDetails(expert);
      setFullExpertProfile(null);
      setmodal_expert_details(true);
      document.body.classList.add("no_padding");
      // Fetch full expert profile details
      if (expert.id) {
        fetchFullExpertProfile(expert.id);
      }
    } else {
      setmodal_expert_details(false);
      setFullExpertProfile(null);
      document.body.classList.remove("no_padding");
    }
  }

  const AddingToCart = async () => {
    // const storedTime = localStorage.getItem("expert_session_timing");

    // if (storedTime && storedTime !== String(selectedSessionMins)) {
    //   alert(`Your saved expert session timing (${storedTime} mins) doesn’t match the current package (${selectedSessionMins} mins). Please re-select your expert session to continue.`);
    //   return;
    // }

    const selectedData = {
      selectedPricePack: selectedPricePack, selectedSlot: selectedSlot, selectedExpert: selectedExpert,
      selectedBookingDate: selectedBookingDate, purpose: selectedPurpose, selected_pack: selectedSessionMins
    };
    console.log("Adding to cart", selectedData)

    let vars: any = []
    if (!(selectedData.selectedBookingDate)) { vars.push('Booking date') };
    if (!(selectedData.selectedPricePack)) { vars.push('Package or Duration') };
    if (!(selectedData.selectedSlot)) { vars.push('Booking slot'); }
    if (!(selectedData.purpose)) { vars.push('Booking purpose') }
    if (vars.length) {
      // alert(`Please select ${vars.join(", ")} !`)
      setAlertMsgg({ ...alertMsgg, open: true, content: `Please select ${vars.join(", ")} !`, type: "error" })
      setTimeout(() => {
        setAlertMsgg(prev => ({ ...prev, open: false }));
      }, 4000);
      return
    }
    setshowloader(true);
    try {
      const response = await axios.post('bookings/add_to_cart', selectedData)
      console.log('response from add to cart', response)
      if (response.status === "ADD_INTO_CART") {
        setTimeout(() => {
          setshowloader(false);
          navigate('/cbookinggroup');
        }, 3000);
      } else if (response.status === "ierror") {
        setshowloader(false);
        setAlertMsgg({ ...alertMsgg, open: true, content: response.error, type: "error", showCartLink: false });
        setTimeout(() => { setAlertMsgg(prev => ({ ...prev, open: false })); }, 4000);
      }
    } catch (error: any) {
      console.log('error', error)
      if (error.response) {
        if (error.response.status === 422) {
          const isAlreadyInCart = error.response.data.error?.toLowerCase().includes("already in your cart");
          setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error", showCartLink: isAlreadyInCart });
          if (!isAlreadyInCart) {
            setTimeout(() => { setAlertMsgg(prev => ({ ...prev, open: false })); }, 4000);
          }
        }
        else if (error.response.status === 401) {
          setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error", showCartLink: false });
          setTimeout(() => { setAlertMsgg(prev => ({ ...prev, open: false })); }, 4000);
        }
        else if (error.response.status === 403) {
          setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error", showCartLink: false });
          setTimeout(() => { window.location.href = "/logout" }, 2000)
        } else {
          setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error", showCartLink: false });
        }
      } else {
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error", showCartLink: false });
      }
      setshowloader(false)
    }
  };

  const AlreadyToCart = async () => {
    navigate('/cbookinggroup');
  }



  const [modal_two_fact, setmodal_two_fact] = useState(false);
  const newtoggle = () => setmodal_two_fact(!modal_two_fact);
  const c_user_role = localStorage.getItem("userole_");

  // new function for display message to new customer
  const Checkuserstatus = async () => {
    try {
      const response = await axios.post("accounts/change_cust_status", { withCredentials: true });

      if (response.status === "SENT") {
        // console.log("response.cust_srl_______",response.cust_srl.first_login)
        const firstLogin = response.cust_srl.first_login;
        console.log("Customer first_login =", firstLogin);

        if (firstLogin === true) {
          setmodal_two_fact(true);
          await Changeuserstatus();
          setTimeout(() => {
            setmodal_two_fact(false);
          }, 10000);
        }
      }
    } catch (error) {
      console.error("Error checking user status", error);
    }
  };

  useEffect(() => {
    if (c_user_role === "cst") {
      Checkuserstatus();
    }
  }, [c_user_role]);

  const Changeuserstatus = async () => {

    try {
      const response = await axios.post('accounts/change_cust_status', { 'change_status': 'change_status' });
      if (response.status === 'DONE') {
        console.log("User Firstlogin status changed.")
      }
    } catch (error: any) {
      console.log('error', error)
      if (error.response) {
        if ([401, 422].includes(error.response.status)) {
          console.log('Error in stripe payment')
          setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
          setTimeout(() => { setAlertMsgg(prev => ({ ...prev, open: false })); }, 4000);
        }
        else if (error.response.status === 403) {
          console.log('Error stripe payment')
          setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
          setTimeout(() => { window.location.href = "/logout" }, 2000)
        } else {
          console.log('An error occurred')
          setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
        }
      } else {
        console.log('An error occurred')
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
      }
      setshowloader(false)
    }

  }


  return (
    <React.Fragment>
      <div className="page-content expertPageHeader">

        {modal_two_fact && (
          <div className="alert alert-success fade show pe-5" role="alert" style={{ fontSize: "15px", width: "40%", maxWidth: "600px", lineHeight: "1.5" }}>
            <div>
              <button
                type="button"
                className="btn-close position-absolute top-0 end-0 m-2"
                aria-label="Close"
                onClick={() => setmodal_two_fact(false)}
                style={{ fontSize: "16px" }}
              >x</button>
            </div>

            Your account requires a password update. Please navigate to your{" "}
            <a href="/cprofile" className="alert-link" style={{ fontWeight: "600" }}>
              Profile
            </a>{" "}
            page to set a new password before continuing.
          </div>
        )}
        {/* <div>
          <Modal isOpen={modal_two_fact} centered className="rounded-4">
            <ModalHeader toggle={newtoggle}>
              <div className="modal-title mt-0 font-size-16 text-dark">
                password chnage message
              </div>
            </ModalHeader>
            <ModalBody className="text-center">
              <h4 className="mb-3 text-danger">Please go the profile tab for chnage the password</h4>
            </ModalBody>
          </Modal>
        </div> */}





        {/* <Navbar leftMenu={openColl} /> */}
        {alertMsgg.open && (
          <Alert
            color={alertMsgg.type === "success" ? "success" : "danger"}
            toggle={handleAlertMsggClose}
            style={{ fontWeight: "bold" }}
          >
            {alertMsgg.content}
            {alertMsgg.showCartLink && (
              <span
                className="ms-2 text-decoration-underline"
                style={{ cursor: "pointer" }}
                onClick={() => navigate('/cbookinggroup')}
              >
                View Cart
              </span>
            )}
          </Alert>
        )}

        {/* <Breadcrumbs title="Domains " breadcrumbItem="Domains" /> */}

        <div className="loaderContainer" hidden={!showloader}>
          <div className="spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <Row className="mt-lg-0 expertContent p-4">
          {/* <Col md="3">
              <Card className="rounded-0 rightBarnew">
                <CardBody>
                  <div className="accordion accordionCustom mx-2" id="accordion">
                    {domains.map((domain, index) => (
                      (domain?.navroles?.includes(localStorage.getItem('userole_') || "") || localStorage.getItem('userole_') == "adm") ? 
                      (<div className="accordion-item" key={domain.id}>
                        <h2 className="accordion-header" id={`heading${domain.id}`}>
                          <button
                            className={classnames("accordion-button text-capitalize", {
                            collapsed: !collapsed[`domain_${domain.id}`]
                            })}
                            type="button"
                            onClick={() => handleAccordionToggle(domain.id)} 
                            style={{ cursor: "pointer" }}>
                              <i className={`${domain?.iconclass || 'bx bx-grid-small'} me-1`}></i>
                              {domain.name}
                          </button> 
                        </h2>
                        <Collapse isOpen={collapsed[`domain_${domain.id}`]} className="accordion-collapse">
                          <div className="accordion-body">
                          
                            <ul>
                            {domain?.navsubdomains?.map((subdomain, subindex) => (
                            (subdomain?.navroles?.includes(localStorage.getItem('userole_') || "") || localStorage.getItem('userole_') == "adm") ?  (
                              <li key={subdomain.id} onClick={() => updatesubdomaincontent(domain.id, subdomain.id)} className={`${(subdomain.id == selectedSubdomain?.id ? "text-primary activeMenu" : '')}`}><i className={`${subdomain?.iconclass || 'bx bx-grid-small'} me-1`}></i>{subdomain.name}</li>
                            ) : null
                            ))}
                            </ul>
                            
                          </div>
                        </Collapse>
                      </div>) : null
                    ))}
                    {(["prt", "emp"].includes(localStorage.getItem('userole_') || "")) ? null : (
                    <div className="d-grid gap-2">
                      <p className={`${((selectedSubdomain) ? "mb-0 normalMenu" : "activeMenu text-secondary fw-medium normalMenu mb-0")}`} id={`heading${0}`} onClick={() => updatesubdomaincontent(0, 0)}><i className="bx bxs-user me-1"></i>All Experts</p>
                    </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col> */}
          {/* latest */}
          <Col md="12" className="">
            {false && isInactiveCst ? ( // FREE_PLATFORM_MODE: Always show experts. To restore: isInactiveCst ? (
              <Card className="rounded-4 p-3">
                <CardBody>
                  <div className="mt-0 font-size-20 fw-medium text-dark">Subscribe</div>
                  <div className="py-4">
                    <p className="font-size-15 mb-1">To book an expert, please choose a monthly subscription plan from the options below.</p>
                    <p className="font-size-15">Thank you for your time and support!</p>
                    <Row className="mt-4">
                      {packages.length > 0 && packages.map((pack) => {
                        const colSize = packages.length >= 3 ? 4 : packages.length === 2 ? 6 : 12;

                        return (
                          <Col md={colSize} key={pack.id} className={pack.mpopular ? "mpopular mb-4" : "mb-4"}>
                            <Card className="rounded-4 border border-dark h-100 ">
                              <CardBody>
                                {pack.mpopular && (
                                  <span className="badge bg-primary rounded-5 font-size-12 activeplanTag px-2 py-1"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="me-1 startTag e-font-icon-svg e-fas-asterisk" viewBox="0 0 512 512"><path d="M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"></path></svg>Most Popular</span>
                                )}
                                <div className="text-dark py-2">
                                  <p className={pack.mpopular ? "mb-3 font-size-15 fw-medium text-white" : "mb-3 font-size-15 fw-medium text-secondary"}>{pack.name}</p>
                                  <h1 className={pack.mpopular ? "text-white font-size-25" : "font-size-25 text-secondary"}>${pack.price.toFixed(2)}<span className={pack.mpopular ? "text-white font-size-10" : "font-size-10"}>/month</span></h1>

                                  {Number(pack?.trial_days) > 0 && (
                                    <p className={pack.mpopular ? "text-white fw-thin font-size-13" : "font-size-13 text-dark"}>🎉 Enjoy {pack?.trial_days} days free (New members only)</p>
                                  )}

                                  <p className={pack.mpopular ? "text-white fw-thin font-size-13" : "font-size-13 text-dark"}>{pack.description}</p>
                                </div>
                                {/* <div className="d-grid gap-2">
                                    <Button color="primary" type="button" className="btn-md">Start with {pack.name}</Button>
                                  </div> */}
                                <div className="d-grid gap-2">
                                  <Button
                                    type="button"
                                    className={pack.mpopular ? "bg-white text-dark fw-medium" : "btn bg-primary btn-md border-0"}
                                    onClick={() => bookSubscription(pack.id)}  // pass pack ID here
                                  >
                                    Start with {pack.name}
                                  </Button>
                                </div>

                                <div className="mt-4">
                                  <p className={pack.mpopular ? "text-white mb-2 font-size-14 fw-medium" : "mb-2 font-size-14 fw-medium text-muted"}>Features</p>
                                  <ul className={pack.mpopular ? "text-white font-size-14 text-dark ps-0 list-style-none starStyleList" : "font-size-14 text-dark ps-0 list-style-none starStyleList"}>
                                    {pack.features.map((item: any, index: number) => (
                                      <li key={index} className="mb-1 font-size-13"><svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M10.5 15.25C10.307 15.2353 10.1276 15.1455 9.99998 15L6.99998 12C6.93314 11.8601 6.91133 11.7029 6.93756 11.55C6.96379 11.3971 7.03676 11.2562 7.14643 11.1465C7.2561 11.0368 7.39707 10.9638 7.54993 10.9376C7.70279 10.9114 7.86003 10.9332 7.99998 11L10.47 13.47L19 5.00004C19.1399 4.9332 19.2972 4.91139 19.45 4.93762C19.6029 4.96385 19.7439 5.03682 19.8535 5.14649C19.9632 5.25616 20.0362 5.39713 20.0624 5.54999C20.0886 5.70286 20.0668 5.86009 20 6.00004L11 15C10.8724 15.1455 10.6929 15.2353 10.5 15.25Z" fill={pack.mpopular ? "#fff" : "#0a8543"}></path><path d="M12 21C10.3915 20.9974 8.813 20.5638 7.42891 19.7443C6.04481 18.9247 4.90566 17.7492 4.12999 16.34C3.54037 15.29 3.17596 14.1287 3.05999 12.93C2.87697 11.1721 3.2156 9.39921 4.03363 7.83249C4.85167 6.26578 6.1129 4.9746 7.65999 4.12003C8.71001 3.53041 9.87134 3.166 11.07 3.05003C12.2641 2.92157 13.4719 3.03725 14.62 3.39003C14.7224 3.4105 14.8195 3.45215 14.9049 3.51232C14.9903 3.57248 15.0622 3.64983 15.116 3.73941C15.1698 3.82898 15.2043 3.92881 15.2173 4.03249C15.2302 4.13616 15.2214 4.2414 15.1913 4.34146C15.1612 4.44152 15.1105 4.53419 15.0425 4.61352C14.9745 4.69286 14.8907 4.75712 14.7965 4.80217C14.7022 4.84723 14.5995 4.87209 14.4951 4.87516C14.3907 4.87824 14.2867 4.85946 14.19 4.82003C13.2186 4.52795 12.1987 4.43275 11.19 4.54003C10.193 4.64212 9.22694 4.94485 8.34999 5.43003C7.50512 5.89613 6.75813 6.52088 6.14999 7.27003C5.52385 8.03319 5.05628 8.91361 4.77467 9.85974C4.49307 10.8059 4.40308 11.7987 4.50999 12.78C4.61208 13.777 4.91482 14.7431 5.39999 15.62C5.86609 16.4649 6.49084 17.2119 7.23999 17.82C8.00315 18.4462 8.88357 18.9137 9.8297 19.1953C10.7758 19.4769 11.7686 19.5669 12.75 19.46C13.747 19.3579 14.713 19.0552 15.59 18.57C16.4349 18.1039 17.1818 17.4792 17.79 16.73C18.4161 15.9669 18.8837 15.0864 19.1653 14.1403C19.4469 13.1942 19.5369 12.2014 19.43 11.22C19.4201 11.1169 19.4307 11.0129 19.461 10.9139C19.4914 10.8149 19.5409 10.7228 19.6069 10.643C19.6728 10.5631 19.7538 10.497 19.8453 10.4485C19.9368 10.3999 20.0369 10.3699 20.14 10.36C20.2431 10.3502 20.3471 10.3607 20.4461 10.3911C20.5451 10.4214 20.6372 10.471 20.717 10.5369C20.7969 10.6028 20.863 10.6839 20.9115 10.7753C20.9601 10.8668 20.9901 10.9669 21 11.07C21.1821 12.829 20.842 14.6026 20.0221 16.1695C19.2022 17.7363 17.9389 19.0269 16.39 19.88C15.3288 20.4938 14.1495 20.8755 12.93 21C12.62 21 12.3 21 12 21Z" fill={pack.mpopular ? "#fff" : "#0a8543"}></path></svg> {item.feature} </li>))}
                                  </ul>
                                </div>
                              </CardBody>
                            </Card>
                          </Col>
                        );
                      })}
                    </Row>
                  </div>
                </CardBody>
              </Card>
            ) : (
              <Card className="rounded-4 p-2">
                <CardBody className=" p-0">
                  {(
                    // selected subdomain's content
                    (selectedSubdomain && (selectedSubdomain?.navroles?.includes(localStorage.getItem('userole_') || "") || localStorage.getItem('userole_') == "adm")) ?
                      (
                        <div>
                          <div>
                            <div>
                              {selectedSubdomain?.navcontents.map((ncontent, ncontentindex) => {
                                switch (ncontent.itype) {
                                  case 'image':
                                    return (
                                      <div className={`mt-2 ${ncontent.classes}`} key={ncontentindex} id={`${selectedSubdomain.id}_${ncontent.id}`}>
                                        <img src={ncontent.image} className="w-100 rounded-4 mb-3" alt="Responsive img" />
                                      </div>
                                    );
                                  case 'text':
                                    return (() => {
                                      const contentKey = `${ncontent.id}_${ncontentindex}`;
                                      // Use .text when available, otherwise fallback to rendering HTML
                                      const htmlBlock = (
                                        <div
                                          className={` ${ncontent.classes}`}
                                          key={contentKey}
                                          id={`${ncontent.id}`}
                                          dangerouslySetInnerHTML={{ __html: ncontent.text }}
                                        />
                                      );
                                      switch (ncontent.ttype) {
                                        // case 'H1': return (<div className={` ${ncontent.classes}`} key={ncontentindex} id={`${ncontent.id}`}> <h1 className="font-size-18">{ncontent.text} </h1> </div>);

                                        // case 'H2': return (<div className={` ${ncontent.classes}`} key={ncontentindex} id={`${ncontent.id}`}> <h2 className="font-size-17">{ncontent.text} </h2> </div>);

                                        // case 'H3': return (<div className={` ${ncontent.classes}`} key={ncontentindex} id={`${ncontent.id}`}> <h3 className="font-size-16">{ncontent.text} </h3> </div>);

                                        // case 'H4': return (<div className={` ${ncontent.classes}`} key={ncontentindex} id={`${ncontent.id}`}> <h4 className="font-size-15">{ncontent.text} </h4> </div>);

                                        // case 'H5': return (<div className={` ${ncontent.classes}`} key={ncontentindex} id={`${ncontent.id}`}> <h5 className="font-size-14">{ncontent.text} </h5> </div>);

                                        // case 'H6': return (<div className={` ${ncontent.classes}`} key={ncontentindex} id={`${ncontent.id}`}> <h6 className="font-size-13">{ncontent.text} </h6> </div>);

                                        // case 'P': return (<div className={` ${ncontent.classes}`} key={ncontentindex} id={`${ncontent.id}`}> <p> {ncontent.text}</p> </div>);

                                        default:
                                          return (
                                            <div
                                              className={`font-size-15 ${ncontent.classes} my-4`} // margin top & bottom
                                              key={ncontentindex}
                                              id={`${ncontent.id}`}
                                            >
                                              <div className="mt-2" dangerouslySetInnerHTML={{ __html: ncontent.text || '' }} />
                                            </div>
                                          );

                                      }
                                    })();
                                  case 'video':
                                    return (
                                      <div className={ncontent.classes} key={ncontentindex} id={`${selectedSubdomain.id}_${ncontent.id}`}>
                                        <div className="rounded-4 overflow-hidden mb-3 border">
                                          <video width="100%" height="100%" controls autoPlay muted playsInline>
                                            <source src={process.env.REACT_APP_BASE_URL + ncontent.video} type="video/mp4" />
                                          </video>
                                        </div>

                                      </div>
                                    );
                                  case 'rcomponent':
                                    {

                                      return (
                                        <div className={`font-size-16 ${ncontent.classes}`} key={ncontentindex} id={`${selectedSubdomain.id}_${ncontent.id}`}>
                                          {CustomReactComponents({ component: ncontent.rcomponent, domain: myParams.did })}
                                        </div>
                                      );
                                    }
                                  case 'experts':
                                    return (
                                      <div className={ncontent.classes} key={ncontentindex} id={`${selectedSubdomain.id}_${ncontent.id}`}>
                                        {localStorage.getItem('userole_') === "cst" && (
                                          <div className="d-flex justify-content-end mb-3">
                                            <Button color="primary" className="btn-sm btn-rounded position-relative" onClick={() => navigate('/cbookinggroup')}>
                                              <i className="bx bx-cart font-size-16 align-middle me-1"></i>
                                              Cart
                                              {cartLength > 0 && (
                                                <span className="badge bg-danger rounded-pill ms-1">{cartLength}</span>
                                              )}
                                            </Button>
                                          </div>
                                        )}
                                        <Row className="mb-3 bgImgGradient row p-3 rounded-4 mx-1">
                                          <Col md={4}>
                                            <label className="col-form-label text-dark">SubCategory</label>
                                            <div className="">
                                              <select className="form-control" value={subcat} onChange={(e) => setsubcat(e.target.value)} id="filter_subcat" name="filter_subcat">
                                                <option>All</option>
                                                {subcat_opts?.map((subcat: any, subcatindex: any) => (
                                                  <option key={subcatindex} value={subcat.id}>{subcat.title}</option>
                                                ))}
                                              </select>
                                            </div>
                                          </Col>
                                          <Col md={4}>
                                            <label className="col-form-label text-dark">Budget</label>
                                            <div>
                                              <select className="form-control" value={budget} onChange={(e) => setbudget(e.target.value)} id="filter_budget" name="filter_budget">
                                                <option>All</option>
                                                {budget_opts?.map((option, index: any) => (
                                                  <option key={index} value={option}>{option}</option>
                                                ))}
                                              </select>
                                            </div>
                                          </Col>
                                          <Col md={4}>
                                            <label className="col-form-label text-dark">Availabilty</label>
                                            <div className="">
                                              <select className="form-control" value={avail} onChange={(e) => setavail((e.target.value == "Available"))} id="filter_avail" name="filter_avail">
                                                <option>All</option>
                                                <option value={"Available"}>Available</option>
                                                <option value={"Unavailable"}>Unavailable</option>
                                              </select>
                                            </div>
                                          </Col>


                                        </Row>
                                        <Row>
                                          {(ncontent.category && gettheexperts(ncontent.category).length) ? (gettheexperts(ncontent.category).map((expert, expertindex) => (
                                            <Col xl={6} key={expert.id}>
                                              <Card className="border rounded-3 p-2">
                                                <div className="d-flex no-gutters align-items-top p-0">
                                                  {expert.availability === true ? (
                                                    <Badge className="font-size-11 fw-medium badge-soft-success floatStatus d-flex align-items-center">
                                                      <i className="bx bx-radio-circle-marked font-size-12"></i>Available
                                                    </Badge>) :
                                                    (<Badge className="font-size-11 fw-medium badge-soft-danger floatStatus d-flex align-items-center">
                                                      <i className="bx bx-radio-circle-marked font-size-12"></i>Unavailable
                                                    </Badge>)
                                                  }
                                                  <div>
                                                    <CardImg className="imageExpert" src={expert.image} alt="bizServe" />
                                                  </div>
                                                  <div className="w-100">
                                                    <CardBody className="position-relative pt-2 pb-2 pe-0">
                                                      <CardTitle tag="h4" className="text-primary border-start border-primary ps-2 font-size-12 fw-medium w-fit-box">{expert.category}</CardTitle>
                                                      <h2 className="text-capitalize font-size-16 border-bottom pb-1 text-dark">{expert.title}</h2>

                                                      <div className="d-sm-flex justify-content-between">
                                                        <p className="font-size-12 fw-medium mb-sm-0 mb-1 setWidthPack">
                                                          Packages: <br />
                                                          <span className="text-secondary mt-1 d-block font-size-11">
                                                            {expert.allpacksprices.map((i: any, index: number) =>
                                                              // `$${i}${index !== expert?.allpacksprices.length - 1 ? ', ' : ''}`
                                                              `$${i.price} (${i.session} min)${index !== expert.allpacksprices.length - 1 ? ', ' : ''}`
                                                            )}
                                                          </span>
                                                        </p>
                                                        {(
                                                          <div className="buttonCardStyle d-flex flex-column gap-2">
                                                            <Button color="info" className="btn btn-info btn-sm btn-rounded" aria-pressed="false" onClick={() => toggleExpertDetails(expert)}>
                                                              <i className="bx bx-info-circle font-size-14 align-middle me-1"></i>Know More About Expert
                                                            </Button>
                                                            {/* FREE_PLATFORM_MODE: Always allow booking. To restore: onClick={() => (JSON.parse(localStorage.getItem('cstpack') || "{}")?.active ? booknowform(expert) : booknow())} */}
                                                            {(localStorage.getItem('userole_') == "cst") ?
                                                              (<Button color="primary" className="btn btn-primary btn-sm btn-rounded" aria-pressed="false" onClick={() => booknowform(expert)} > <i className="bx bxs-calendar-plus font-size-16 align-middle me-2"></i>{" "} Book Now</Button>) : (null)}
                                                          </div>
                                                        )}
                                                      </div>
                                                    </CardBody>
                                                  </div>
                                                </div>
                                              </Card>
                                            </Col>
                                          ))) : (
                                            <div className="p-4 text-center w-50 mx-auto">
                                              <i className="bx bx-search-alt display-5 text-danger"></i>
                                              <h5 className="text-danger fw-medium">No experts found </h5>
                                              <p>There are currently no experts available under the selected filter. Please try changing the filters or check back later.</p>
                                            </div>
                                          )}
                                        </Row>
                                      </div>
                                    );
                                  default:
                                    return null;
                                }
                              })}
                            </div>
                          </div>
                        </div>
                      ) :
                      (
                        (["prt", "emp"].includes(localStorage.getItem('userole_') || "")) ? (
                          <div className="">
                            <CardTitle className="h2 font-size-20 pb-3 pt-3 text-center border-bottom mb-4 text-capitalize fw-medium">No content added.</CardTitle>
                          </div>
                        ) : (
                          <div className="">
                            <div className="d-flex justify-content-between align-items-center pb-3 pt-1 border-bottom mb-4">
                              <CardTitle className="h2 font-size-20 text-capitalize fw-medium mb-0">All Experts</CardTitle>
                              {localStorage.getItem('userole_') === "cst" && (
                                <Button color="primary" className="btn-sm btn-rounded position-relative" onClick={() => navigate('/cbookinggroup')}>
                                  <i className="bx bx-cart font-size-16 align-middle me-1"></i>
                                  Cart
                                  {cartLength > 0 && (
                                    <span className="badge bg-danger rounded-pill ms-1">{cartLength}</span>
                                  )}
                                </Button>
                              )}
                            </div>
                            <Row className="mb-3 bgImgGradient row p-3 rounded-4 mx-1">
                              <Col md={3}>
                                <label className="col-form-label text-dark">Category</label>
                                <div className="">
                                  <select className="form-control" value={scat} onChange={(e) => { setscat(e.target.value); setsubcat("All"); { updatesubcatsopts((e.target.value == "All") ? [] : allcats[e.target.value]) } }} id="filter_cat" name="filter_cat">
                                    <option>All</option>
                                    {cat_opts.map((cat: any, catindex: any) => (
                                      <option key={catindex} value={cat.id}>{cat.title}</option>
                                    ))}
                                  </select>
                                </div>
                              </Col>
                              <Col md={3}>
                                <label className="col-form-label text-dark">SubCategory</label>
                                <div>
                                  <select className="form-control" value={subcat} onChange={(e) => setsubcat(e.target.value)} id="filter_subcat" name="filter_subcat">
                                    <option value={"All"}>All</option>
                                    {subcat_opts.map((subcat: any, subcatindex: any) => (
                                      <option key={subcatindex} value={subcat.id}>{subcat.title}</option>
                                    ))}
                                  </select>
                                </div>
                              </Col>
                              <Col md={3}>
                                <label className="col-form-label text-dark">Budget</label>
                                <div>
                                  <select className="form-control" value={budget} onChange={(e) => setbudget(e.target.value)} id="filter_budget" name="filter_budget">
                                    <option value={"All"}>All</option>
                                    {budget_opts.map((option, index: any) => (
                                      <option key={index} value={option}>{option}</option>
                                    ))}
                                  </select>
                                </div>
                              </Col>
                              <Col md={3}>
                                <label className="col-form-label text-dark">Availabilty</label>
                                <div>
                                  <select className="form-control" value={avail} onChange={(e) => { console.log("@@@", e.target.value); setavail(e.target.value) }} id="filter_avail" name="filter_avail">
                                    <option value={"All"} selected>All</option>
                                    <option value="Available">Available</option>
                                    <option value="Unavailable">Unavailable</option>
                                  </select>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              {experts.length ? (experts.map((expert, expertindex) => (
                                <Col xl={6} key={expert.id}>
                                  <Card className="border rounded-3 p-2">
                                    <div className="d-flex no-gutters align-items-top p-0">
                                      {expert.availability === true ? (
                                        <Badge className="font-size-11 fw-medium badge-soft-success floatStatus d-flex align-items-center">
                                          <i className="bx bx-radio-circle-marked font-size-12"></i>Available
                                        </Badge>) :
                                        (<Badge className="font-size-11 fw-medium badge-soft-danger floatStatus d-flex align-items-center">
                                          <i className="bx bx-radio-circle-marked font-size-12"></i>Unavailable
                                        </Badge>)
                                      }
                                      <div >
                                        <CardImg className="imageExpert" src={expert.image} alt="bizServe" />
                                      </div>
                                      <div className="w-100">
                                        <CardBody className="position-relative pt-2 pb-2 pe-0">

                                          <CardTitle tag="h4" className="text-primary border-start border-primary ps-2 font-size-12 fw-medium w-fit-box">{expert.category}</CardTitle>
                                          <h2 className="text-capitalize font-size-16 border-bottom pb-1 text-dark">{expert.title}</h2>

                                          <div className="d-sm-flex justify-content-between">
                                            <p className="font-size-12 fw-medium mb-sm-0 mb-1 setWidthPack">
                                              Packages: <br />
                                              <span className="text-secondary mt-1 d-block font-size-11">
                                                {expert.allpacksprices.map((i: any, index: number) =>
                                                  `$${i.price} (${i.session} mins)${index !== expert.allpacksprices.length - 1 ? ', ' : ''}`
                                                )}
                                              </span>
                                            </p>

                                            {(
                                              <div className="buttonCardStyle d-flex flex-column gap-2">
                                                <Button color="info" className="btn btn-info btn-sm btn-rounded" aria-pressed="false" onClick={() => toggleExpertDetails(expert)}>
                                                  <i className="bx bx-info-circle font-size-14 align-middle me-1"></i>Know More About Expert
                                                </Button>
                                                {(localStorage.getItem('userole_') == "cst") ?
                                                  (<Button color="primary" className="btn btn-primary btn-sm btn-rounded" data-toggle="button" aria-pressed="false" onClick={() => {
                                                    booknowform(expert) // FREE_PLATFORM_MODE: Always allow booking. To restore: (JSON.parse(localStorage.getItem('cstpack') || "{}")?.active ? booknowform(expert) : booknow())
                                                  }}> <i className="bx bxs-calendar-plus font-size-14 align-middle me-2"></i>{" "} Book Now</Button>) : (null)}

                                              </div>
                                            )}
                                          </div>
                                        </CardBody>
                                      </div>
                                    </div>
                                  </Card>
                                </Col>
                              ))) : (
                                <div className="p-4 text-center w-50 mx-auto">
                                  <i className="bx bx-search-alt display-5 text-danger"></i>
                                  <h5 className="text-danger fw-medium">No experts found </h5>
                                  <p>There are currently no experts available under the selected filter. Please try changing the filters or check back later.</p>
                                </div>
                              )}
                            </Row>
                          </div>
                        )
                      )

                  )}
                </CardBody>
                <Modal
                  isOpen={modal_center}
                  toggle={() => {
                    booknow();
                  }}
                  centered
                  size="xl"
                  className="rounded-4">
                  <ModalHeader className="py-3 px-4" toggle={() => {
                    booknow();
                  }}>
                    <div className="modal-title mt-0 font-size-20 text-dark">Subscribe</div>
                  </ModalHeader>
                  <div className="modal-body p-4">
                    <p className="font-size-15 mb-1">To book an expert, please choose a monthly subscription plan from the options below.</p>
                    <p className="font-size-15">Thank you for your time and support!</p>
                    <p className="font-size-15 text-success font-weight-bold">🎉 Enjoy 90 days free — exclusively for new members!</p>
                    <Row className="mt-4">
                      {packages.length > 0 && packages.map((pack) => {
                        const colSize = packages.length >= 3 ? 4 : packages.length === 2 ? 6 : 12;

                        return (
                          <Col md={colSize} key={pack.id} className={pack.mpopular ? "mpopular mb-4" : "mb-4"}>
                            <Card className="rounded-4 border border-dark h-100 ">
                              <CardBody>
                                {pack.mpopular && (
                                  <span className="badge bg-primary rounded-5 font-size-12 activeplanTag px-2 py-1"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="me-1 startTag e-font-icon-svg e-fas-asterisk" viewBox="0 0 512 512"><path d="M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"></path></svg>Most Popular</span>
                                )}
                                <div className="text-dark py-2">
                                  <p className={pack.mpopular ? "mb-3 font-size-15 fw-medium text-white" : "mb-3 font-size-15 fw-medium text-secondary"}>{pack.name}</p>
                                  <h1 className={pack.mpopular ? "text-white font-size-25" : "font-size-25 text-secondary"}>${pack.price.toFixed(2)}<span className={pack.mpopular ? "text-white font-size-10" : "font-size-10"}>/month</span></h1>
                                  <p className={pack.mpopular ? "text-white fw-thin font-size-13" : "font-size-13 text-dark"}>{pack.description}</p>
                                </div>
                                {/* <div className="d-grid gap-2">
                                <Button color="primary" type="button" className="btn-md">Start with {pack.name}</Button>
                              </div> */}
                                <div className="d-grid gap-2">
                                  <Button
                                    type="button"
                                    className={pack.mpopular ? "bg-white text-dark fw-medium" : "btn bg-primary btn-md border-0"}
                                    onClick={() => bookSubscription(pack.id)}  // pass pack ID here
                                  >
                                    Start with {pack.name}
                                  </Button>
                                </div>

                                <div className="mt-4">
                                  <p className={pack.mpopular ? "text-white mb-2 font-size-14 fw-medium" : "mb-2 font-size-14 fw-medium text-muted"}>Features</p>
                                  <ul className={pack.mpopular ? "text-white font-size-14 text-dark ps-0 list-style-none starStyleList" : "font-size-14 text-dark ps-0 list-style-none starStyleList"}>
                                    {pack.features.map((item: any, index: number) => (
                                      <li key={index} className="mb-1 font-size-13"><svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M10.5 15.25C10.307 15.2353 10.1276 15.1455 9.99998 15L6.99998 12C6.93314 11.8601 6.91133 11.7029 6.93756 11.55C6.96379 11.3971 7.03676 11.2562 7.14643 11.1465C7.2561 11.0368 7.39707 10.9638 7.54993 10.9376C7.70279 10.9114 7.86003 10.9332 7.99998 11L10.47 13.47L19 5.00004C19.1399 4.9332 19.2972 4.91139 19.45 4.93762C19.6029 4.96385 19.7439 5.03682 19.8535 5.14649C19.9632 5.25616 20.0362 5.39713 20.0624 5.54999C20.0886 5.70286 20.0668 5.86009 20 6.00004L11 15C10.8724 15.1455 10.6929 15.2353 10.5 15.25Z" fill={pack.mpopular ? "#fff" : "#0a8543"}></path><path d="M12 21C10.3915 20.9974 8.813 20.5638 7.42891 19.7443C6.04481 18.9247 4.90566 17.7492 4.12999 16.34C3.54037 15.29 3.17596 14.1287 3.05999 12.93C2.87697 11.1721 3.2156 9.39921 4.03363 7.83249C4.85167 6.26578 6.1129 4.9746 7.65999 4.12003C8.71001 3.53041 9.87134 3.166 11.07 3.05003C12.2641 2.92157 13.4719 3.03725 14.62 3.39003C14.7224 3.4105 14.8195 3.45215 14.9049 3.51232C14.9903 3.57248 15.0622 3.64983 15.116 3.73941C15.1698 3.82898 15.2043 3.92881 15.2173 4.03249C15.2302 4.13616 15.2214 4.2414 15.1913 4.34146C15.1612 4.44152 15.1105 4.53419 15.0425 4.61352C14.9745 4.69286 14.8907 4.75712 14.7965 4.80217C14.7022 4.84723 14.5995 4.87209 14.4951 4.87516C14.3907 4.87824 14.2867 4.85946 14.19 4.82003C13.2186 4.52795 12.1987 4.43275 11.19 4.54003C10.193 4.64212 9.22694 4.94485 8.34999 5.43003C7.50512 5.89613 6.75813 6.52088 6.14999 7.27003C5.52385 8.03319 5.05628 8.91361 4.77467 9.85974C4.49307 10.8059 4.40308 11.7987 4.50999 12.78C4.61208 13.777 4.91482 14.7431 5.39999 15.62C5.86609 16.4649 6.49084 17.2119 7.23999 17.82C8.00315 18.4462 8.88357 18.9137 9.8297 19.1953C10.7758 19.4769 11.7686 19.5669 12.75 19.46C13.747 19.3579 14.713 19.0552 15.59 18.57C16.4349 18.1039 17.1818 17.4792 17.79 16.73C18.4161 15.9669 18.8837 15.0864 19.1653 14.1403C19.4469 13.1942 19.5369 12.2014 19.43 11.22C19.4201 11.1169 19.4307 11.0129 19.461 10.9139C19.4914 10.8149 19.5409 10.7228 19.6069 10.643C19.6728 10.5631 19.7538 10.497 19.8453 10.4485C19.9368 10.3999 20.0369 10.3699 20.14 10.36C20.2431 10.3502 20.3471 10.3607 20.4461 10.3911C20.5451 10.4214 20.6372 10.471 20.717 10.5369C20.7969 10.6028 20.863 10.6839 20.9115 10.7753C20.9601 10.8668 20.9901 10.9669 21 11.07C21.1821 12.829 20.842 14.6026 20.0221 16.1695C19.2022 17.7363 17.9389 19.0269 16.39 19.88C15.3288 20.4938 14.1495 20.8755 12.93 21C12.62 21 12.3 21 12 21Z" fill={pack.mpopular ? "#fff" : "#0a8543"}></path></svg> {item.feature} </li>))}
                                  </ul>
                                </div>
                              </CardBody>
                            </Card>
                          </Col>
                        );
                      })}
                    </Row>

                  </div>
                </Modal>
                <Modal
                  isOpen={modal_center_form}
                  toggle={() => {
                    booknowform();
                  }}
                  centered
                  size="xl"
                  className="rounded-4">
                  <ModalHeader className="py-3 px-4" toggle={() => {
                    booknowform();
                  }}>
                    <div className="modal-title mt-0 font-size-20 text-dark">Book Now</div>
                  </ModalHeader>
                  <div className="modal-body p-4">
                    {policy_screen_error && (
                      <p
                        style={{
                          backgroundColor: '#fff3cd',
                          color: '#856404',
                          padding: '10px 15px',
                          borderRadius: '6px',
                          border: '1px solid #ffeeba'
                        }}
                        className="mt-2"
                      >
                        This booking is non-refundable as it’s within {newpolicy} hours of the event time {newtime}.
                        Cancellation will not be eligible for a refund.
                      </p>
                    )}
                    <Row className="mt-4">
                      <Col lg={4}>
                        <Card className="rounded-4 shadow-lg bg-dark ">
                          <CardBody className="">
                            <div className="d-flex flex-column no-gutters align-items-top">
                              <div >
                                <CardImg className="imageExpertBooking" src={(selectedExpert?.image)} alt="bizServe" />
                              </div>
                              <div className="w-100">
                                <CardBody className="position-relative ps-0 pb-0">
                                  <CardTitle tag="h4" className="text-primary border-start border-primary ps-2 font-size-14 fw-medium">{selectedExpert?.category}</CardTitle>
                                  <h2 className="text-capitalize text-white font-size-18">{selectedExpert?.title}</h2>
                                  <p className="text-capitalize text-white font-size-5">Expert Timezone : {selectedExpert?.timezone}</p>
                                  {/* {experttimezone} */}
                                </CardBody>
                                {policyendMessage && (
                                  <p
                                    className="mt-2 font-size-14"
                                    style={{
                                      color: '#fff',
                                      padding: '10px 0px',
                                      fontWeight: 400
                                    }}
                                  >
                                    {policyendMessage}
                                  </p>
                                )}
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                        <Card className='border rounded-4 shadow-lg'>
                          <CardBody>
                            <div className="form-group mb-0">
                              <label className="font-size-15 text-dark">Select Date<span className="text-danger px-1">*</span></label>
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="dd M,yyyy"
                                value={selectedBookingDate}
                                onChange={([date]) => {
                                  setSelectedBookingDate(`${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`);
                                }}
                                options={{
                                  inline: true,
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d",
                                  enable: Object.keys(selectedExpert?.bookingavails || {}),
                                  disable: [{ from: "1900-01-01", to: "2099-12-31" }]
                                }}
                              />
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col lg={8}>
                        <Card className='border rounded-4 shadow-lg '>
                          <CardBody>
                            <div className="form-group mb-3">
                              <label className="font-size-15 text-dark mb-3">Select Duration<span className="text-danger px-1">*</span></label>
                              <div className="d-flex durationCard flex-wrap">

                                {selectedExpert?.allpacks.map((pack: any, packindex) => (
                                  <div className="form-check durationBox ps-0 pe-2 mb-3" key={packindex}>
                                    <input
                                      className="form-check-input d-none"
                                      type="radio"
                                      name="pricepack"
                                      id={`pricepack${pack.id}`}
                                      value={pack.id}
                                      onChange={(event: any) => {
                                        setSelectedPricePack(event.target.value);
                                        handleSessionMins(pack);
                                      }}
                                    />
                                    <label
                                      className="form-check-label rounded-4"
                                      htmlFor={`pricepack${pack.id}`}
                                    >
                                      <p style={{ display: 'none' }}>{pack.id}</p>
                                      <span className="durationPrice bg-dark text-white">${pack.price}</span>
                                      <p className="text-dark font-size-15 mt-2 mb-0">{pack.session_mins} Mins</p>
                                    </label>
                                  </div>
                                ))}

                              </div>
                            </div>
                            <div className="form-group mb-0">
                              <label className="font-size-15 text-dark mb-3">Available slots  <span className="text-danger px-1">*</span></label>
                              <div className="d-flex timeSlotsCard flex-wrap">

                                {selectedBookingDate && selectedExpert?.bookingavails[selectedBookingDate] ? (
                                  (selectedExpert?.bookingavails[selectedBookingDate]?.map((slot: any, slotindex) => (
                                    <div className="form-check ps-0 pe-2 mb-2 widthSetLebel">
                                      <input
                                        className="form-check-input d-none"
                                        type="radio"
                                        name="timeslots"
                                        id={`timeslots_${slotindex}`}
                                        value={slot}
                                        onChange={(event: any) => { setSelectedSlot(event.target.value) }}
                                      />
                                      <label
                                        className="form-check-label rounded-3 text-dark font-size-16 mb-0"
                                        htmlFor={`timeslots_${slotindex}`}
                                      >{slot}
                                      </label>
                                    </div>
                                  )))
                                ) : (
                                  <div className="mx-auto">
                                    <div className="text-center">
                                      <i className="display-2 mdi mdi-calendar-blank text-primary"></i>
                                      <h4 className="text-primary">Select a Date</h4>
                                      <p className="text-muted">Please select a date to view available slots</p>
                                    </div>
                                  </div>
                                )}

                              </div>
                            </div>
                          </CardBody>
                        </Card>
                        <Card className='border rounded-4 shadow-lg '>
                          <CardBody>
                            <div className="mb-3">
                              <Label htmlFor="booking purpose">Purpose<span className="text-danger px-1">*</span></Label>
                              <Input
                                tag="textarea"
                                className="mb-3"
                                id="booking purpose"
                                name="booking purpose"
                                value={selectedPurpose}
                                onChange={(e) => setSelectedPurpose(e.target.value)}
                                rows={5}
                                placeholder="Write a purpose"
                              />
                            </div>
                          </CardBody>
                        </Card>
                        <div className="d-flex justify-content-end gap-2">
                          <button className="btn btn-outline-primary btn-lg position-relative" onClick={() => navigate('/cbookinggroup')}>
                            <i className="bx bx-cart me-1"></i>
                            View Cart
                            {cartLength > 0 && (
                              <span className="badge bg-danger rounded-pill ms-1">{cartLength}</span>
                            )}
                          </button>
                          <button className="btn btn-primary btn-lg" onClick={AddingToCart}>
                            Add To Cart
                          </button>
                        </div>
                        {/* &nbsp;
                        <div className="d-flex justify-content-end">
                              <button className="btn btn-primary btn-lg" onClick={booktheexpert}>Book Expert</button>
                        </div> */}
                      </Col>
                    </Row>
                  </div>
                </Modal>
                {/* Checkout Disclaimer Modal */}
                <Modal isOpen={showDisclaimerModal} toggle={() => { setShowDisclaimerModal(false); setPendingCheckoutAction(null); setDisclaimerAccepted(false); }} centered size="md">
                  <ModalHeader toggle={() => { setShowDisclaimerModal(false); setPendingCheckoutAction(null); setDisclaimerAccepted(false); }}>
                    Before You Proceed
                  </ModalHeader>
                  <ModalBody>
                    <div className="mb-3">
                      <Label check className="d-flex align-items-start gap-2" style={{ cursor: 'pointer' }}>
                        <input
                          type="checkbox"
                          checked={disclaimerAccepted}
                          onChange={(e) => setDisclaimerAccepted(e.target.checked)}
                          className="form-check-input mt-1"
                          style={{ width: '18px', height: '18px', cursor: 'pointer', flexShrink: 0 }}
                        />
                        <span>{checkoutDisclaimer?.text}</span>
                      </Label>
                    </div>
                    <div className="d-flex justify-content-end gap-2 mt-3">
                      <Button color="secondary" onClick={() => { setShowDisclaimerModal(false); setPendingCheckoutAction(null); setDisclaimerAccepted(false); }}>Cancel</Button>
                      <Button
                        color="primary"
                        disabled={!disclaimerAccepted}
                        onClick={() => {
                          setShowDisclaimerModal(false);
                          if (pendingCheckoutAction) pendingCheckoutAction();
                          setPendingCheckoutAction(null);
                          setDisclaimerAccepted(false);
                        }}
                      >
                        Proceed to Checkout
                      </Button>
                    </div>
                  </ModalBody>
                </Modal>

                <Modal
                  isOpen={modal_expert_details}
                  toggle={() => {
                    toggleExpertDetails();
                  }}
                  centered
                  size="lg"
                  className="rounded-4">
                  <ModalHeader className="py-3 px-4" toggle={() => {
                    toggleExpertDetails();
                  }}>
                    <div className="modal-title mt-0 font-size-20 text-dark">Expert Details</div>
                  </ModalHeader>
                  <ModalBody style={{ maxHeight: 'calc(90vh - 100px)', overflowY: 'auto' }}>
                    {loadingExpertDetails && (
                      <div className="text-center py-4">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-2 text-muted">Loading expert details...</p>
                      </div>
                    )}
                    {selectedExpertDetails && !loadingExpertDetails && (() => {
                      const expertData = fullExpertProfile || selectedExpertDetails.fullExpertData || selectedExpertDetails;
                      const userData = expertData.user || expertData;

                      return (
                        <div>
                          {/* Expert Profile Section at Top */}
                          <div className="mb-4">
                            <Row>
                              <Col md={12}>
                                <div className="d-flex align-items-center gap-3 mb-3">
                                  {selectedExpertDetails.image ? (
                                    <img
                                      src={selectedExpertDetails.image}
                                      alt="Expert"
                                      style={{
                                        width: '80px',
                                        height: '80px',
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                        border: '2px solid #dee2e6'
                                      }}
                                    />
                                  ) : (
                                    <div
                                      style={{
                                        width: '80px',
                                        height: '80px',
                                        borderRadius: '50%',
                                        background: '#e9ecef',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '32px',
                                        color: '#6c757d'
                                      }}
                                    >
                                      {selectedExpertDetails.title?.[0] || 'E'}
                                    </div>
                                  )}
                                  <div className="flex-grow-1">
                                    <h4 className="mb-2 d-flex align-items-center gap-2">
                                      <User size={24} />
                                      {selectedExpertDetails.title}
                                    </h4>
                                    {expertData.professional_title && (
                                      <p className="text-muted mb-2">{expertData.professional_title}</p>
                                    )}
                                    <div className="mb-2">
                                      <Badge color="primary" className="me-2">
                                        {selectedExpertDetails.category}
                                      </Badge>
                                      {selectedExpertDetails.availability === true ? (
                                        <Badge color="success">
                                          <i className="bx bx-radio-circle-marked font-size-12"></i> Available
                                        </Badge>
                                      ) : (
                                        <Badge color="danger">
                                          <i className="bx bx-radio-circle-marked font-size-12"></i> Unavailable
                                        </Badge>
                                      )}
                                    </div>
                                    {selectedExpertDetails.rating && (
                                      <div className="d-flex align-items-center gap-1">
                                        <Star size={16} style={{ color: '#ffc107', fill: '#ffc107' }} />
                                        <span className="text-muted">{selectedExpertDetails.rating}</span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>

                          {/* Business Introduction */}
                          {expertData.business_introduction && (
                            <div className="mb-4">
                              <h5 className="mb-3 d-flex align-items-center gap-2">
                                <BookOpen size={20} />
                                About
                              </h5>
                              <p className="text-muted">{expertData.business_introduction}</p>
                            </div>
                          )}

                          {/* Professional Identity & Branding */}
                          {(expertData.business_name || expertData.business_logo) && (
                            <div className="mb-4">
                              <h5 className="mb-3 d-flex align-items-center gap-2">
                                <Building2 size={20} />
                                Professional Identity
                              </h5>
                              <Row>
                                {expertData.business_name && (
                                  <Col md={6} className="mb-2">
                                    <strong>Business Name:</strong> {expertData.business_name}
                                  </Col>
                                )}
                                {expertData.buissness_phone && (
                                  <Col md={6} className="mb-2">
                                    <strong>Business Phone:</strong>
                                    <span className="ms-2">
                                      <Phone size={14} style={{ display: 'inline', verticalAlign: 'middle', marginRight: '4px' }} />
                                      {expertData.buissness_phone}
                                    </span>
                                  </Col>
                                )}
                              </Row>
                            </div>
                          )}

                          {/* Contact Information */}
                          {(userData.email || userData.phone) && (
                            <div className="mb-4">
                              <h5 className="mb-3 d-flex align-items-center gap-2">
                                <Mail size={20} />
                                Contact Information
                              </h5>
                              <Row>
                                {userData.email && (
                                  <Col md={6} className="mb-2">
                                    <strong>Email:</strong>
                                    <a href={`mailto:${userData.email}`} className="ms-2">
                                      {userData.email}
                                    </a>
                                  </Col>
                                )}
                                {userData.phone && (
                                  <Col md={6} className="mb-2">
                                    <strong>Phone:</strong>
                                    <span className="ms-2">
                                      <Phone size={14} style={{ display: 'inline', verticalAlign: 'middle', marginRight: '4px' }} />
                                      {userData.phone}
                                    </span>
                                  </Col>
                                )}
                              </Row>
                            </div>
                          )}

                          {/* Credentials & Qualifications */}
                          {(expertData.certifications || expertData.licenses || expertData.education_background || expertData.years_of_experience || expertData.expertise_level) && (
                            <div className="mb-4">
                              <h5 className="mb-3 d-flex align-items-center gap-2">
                                <GraduationCap size={20} />
                                Credentials & Qualifications
                              </h5>
                              <Row>
                                {expertData.certifications && (
                                  <Col md={12} className="mb-2">
                                    <strong>Certifications:</strong>
                                    <p className="text-muted mt-1">{expertData.certifications}</p>
                                  </Col>
                                )}
                                {expertData.licenses && (
                                  <Col md={12} className="mb-2">
                                    <strong>Licenses:</strong>
                                    <p className="text-muted mt-1">{expertData.licenses}</p>
                                  </Col>
                                )}
                                {expertData.education_background && (
                                  <Col md={12} className="mb-2">
                                    <strong>Education:</strong>
                                    <p className="text-muted mt-1">{expertData.education_background}</p>
                                  </Col>
                                )}
                                {expertData.years_of_experience && (
                                  <Col md={6} className="mb-2">
                                    <strong>Years of Experience:</strong> {expertData.years_of_experience}
                                  </Col>
                                )}
                                {expertData.expertise_level && (
                                  <Col md={6} className="mb-2">
                                    <strong>Expertise Level:</strong>
                                    <Badge color="info" className="ms-2">{expertData.expertise_level}</Badge>
                                  </Col>
                                )}
                              </Row>
                            </div>
                          )}

                          {/* Location & Service Areas */}
                          {(expertData.address_line1 || expertData.city || expertData.state || expertData.country || expertData.service_areas || selectedExpertDetails.timezone || selectedExpertDetails.country_code) && (
                            <div className="mb-4">
                              <h5 className="mb-3 d-flex align-items-center gap-2">
                                <MapPin size={20} />
                                Location & Service Areas
                              </h5>
                              <Row>
                                {(expertData.address_line1 || expertData.address_line2) && (
                                  <Col md={12} className="mb-2">
                                    <strong>Address:</strong>
                                    <div className="text-muted mt-1">
                                      {expertData.address_line1 && <div>{expertData.address_line1}</div>}
                                      {expertData.address_line2 && <div>{expertData.address_line2}</div>}
                                      {(expertData.city || expertData.state || expertData.zipcode) && (
                                        <div>
                                          {expertData.city}
                                          {expertData.city && expertData.state && ', '}
                                          {expertData.state}
                                          {expertData.zipcode && ` ${expertData.zipcode}`}
                                        </div>
                                      )}
                                      {expertData.country && <div>{expertData.country}</div>}
                                    </div>
                                  </Col>
                                )}
                                {selectedExpertDetails.timezone && (
                                  <Col md={6} className="mb-2">
                                    <strong>Timezone:</strong> {selectedExpertDetails.timezone}
                                  </Col>
                                )}
                                {selectedExpertDetails.country_code && (
                                  <Col md={6} className="mb-2">
                                    <strong>Country Code:</strong> {selectedExpertDetails.country_code}
                                  </Col>
                                )}
                                {selectedExpertDetails.expert_local_time && (
                                  <Col md={6} className="mb-2">
                                    <strong>Local Time:</strong> {selectedExpertDetails.expert_local_time}
                                  </Col>
                                )}
                                {expertData.service_areas && (
                                  <Col md={12} className="mb-2">
                                    <strong>Service Areas:</strong>
                                    <p className="text-muted mt-1">{expertData.service_areas}</p>
                                  </Col>
                                )}
                              </Row>
                            </div>
                          )}

                          {/* Skills & Specializations */}
                          {(expertData.specializations || expertData.languages_spoken || expertData.expert_tags) && (
                            <div className="mb-4">
                              <h5 className="mb-3 d-flex align-items-center gap-2">
                                <Award size={20} />
                                Skills & Specializations
                              </h5>
                              <Row>
                                {expertData.specializations && (
                                  <Col md={12} className="mb-2">
                                    <strong>Specializations:</strong>
                                    <p className="text-muted mt-1">{expertData.specializations}</p>
                                  </Col>
                                )}
                                {expertData.languages_spoken && (
                                  <Col md={6} className="mb-2">
                                    <strong>Languages:</strong>
                                    <span className="ms-2">
                                      <Languages size={14} style={{ display: 'inline', verticalAlign: 'middle', marginRight: '4px' }} />
                                      {expertData.languages_spoken}
                                    </span>
                                  </Col>
                                )}
                                {expertData.expert_tags && (
                                  <Col md={12} className="mb-2">
                                    <strong>Expert Tags:</strong>
                                    <div className="mt-1">
                                      {expertData.expert_tags.split(',').map((tag: string, idx: number) => (
                                        <Badge key={idx} color="secondary" className="me-1 mb-1">{tag.trim()}</Badge>
                                      ))}
                                    </div>
                                  </Col>
                                )}
                              </Row>
                            </div>
                          )}

                          {/* Professional Tools */}
                          {expertData.tools && (
                            <div className="mb-4">
                              <h5 className="mb-3 d-flex align-items-center gap-2">
                                <Wrench size={20} />
                                Professional Tools
                              </h5>
                              <Row>
                                <Col md={12} className="mb-2">
                                  <p className="text-muted">{expertData.tools}</p>
                                </Col>
                              </Row>
                            </div>
                          )}

                          {/* Client Focus & Experience */}
                          {(expertData.client_types || expertData.industry_experience) && (
                            <div className="mb-4">
                              <h5 className="mb-3 d-flex align-items-center gap-2">
                                <Users size={20} />
                                Client Focus & Experience
                              </h5>
                              <Row>
                                {expertData.client_types && (
                                  <Col md={12} className="mb-2">
                                    <strong>Client Types:</strong>
                                    <p className="text-muted mt-1">{expertData.client_types}</p>
                                  </Col>
                                )}
                                {expertData.industry_experience && (
                                  <Col md={12} className="mb-2">
                                    <strong>Industry Experience:</strong>
                                    <p className="text-muted mt-1">{expertData.industry_experience}</p>
                                  </Col>
                                )}
                              </Row>
                            </div>
                          )}

                          {/* Portfolio & Media */}
                          {(expertData.profile_video || expertData.case_studies || expertData.resume) && (
                            <div className="mb-4">
                              <h5 className="mb-3 d-flex align-items-center gap-2">
                                <FileText size={20} />
                                Portfolio & Media
                              </h5>
                              <Row>
                                {expertData.profile_video && (
                                  <Col md={12} className="mb-2">
                                    <strong>Profile Video:</strong>
                                    <a href={expertData.profile_video} target="_blank" rel="noopener noreferrer" className="ms-2">
                                      View Video <ExternalLink size={14} style={{ display: 'inline', verticalAlign: 'middle' }} />
                                    </a>
                                  </Col>
                                )}
                                {expertData.case_studies && (
                                  <Col md={12} className="mb-2">
                                    <strong>Case Studies:</strong>
                                    <p className="text-muted mt-1">{expertData.case_studies}</p>
                                  </Col>
                                )}
                                {expertData.resume && (
                                  <Col md={12} className="mb-2">
                                    <strong>Resume:</strong>
                                    <a href={expertData.resume} target="_blank" rel="noopener noreferrer" className="ms-2">
                                      View Resume <ExternalLink size={14} style={{ display: 'inline', verticalAlign: 'middle' }} />
                                    </a>
                                  </Col>
                                )}
                              </Row>
                            </div>
                          )}

                          {/* Website & Social Media */}
                          {(expertData.website || expertData.linkedin_url || expertData.facebook_url || expertData.x_url || expertData.instagram_url || expertData.youtube_url || expertData.professional_blog || expertData.portfolio_url) && (
                            <div className="mb-4">
                              <h5 className="mb-3 d-flex align-items-center gap-2">
                                <Globe size={20} />
                                Website & Social Media
                              </h5>
                              <Row>
                                {expertData.website && (
                                  <Col md={6} className="mb-2">
                                    <a href={expertData.website} target="_blank" rel="noopener noreferrer" className="d-flex align-items-center gap-2">
                                      <Globe size={16} />
                                      <span>Website</span>
                                      <ExternalLink size={14} />
                                    </a>
                                  </Col>
                                )}
                                {expertData.linkedin_url && (
                                  <Col md={6} className="mb-2">
                                    <a href={expertData.linkedin_url} target="_blank" rel="noopener noreferrer" className="d-flex align-items-center gap-2">
                                      <Linkedin size={16} />
                                      <span>LinkedIn</span>
                                      <ExternalLink size={14} />
                                    </a>
                                  </Col>
                                )}
                                {expertData.facebook_url && (
                                  <Col md={6} className="mb-2">
                                    <a href={expertData.facebook_url} target="_blank" rel="noopener noreferrer" className="d-flex align-items-center gap-2">
                                      <Facebook size={16} />
                                      <span>Facebook</span>
                                      <ExternalLink size={14} />
                                    </a>
                                  </Col>
                                )}
                                {expertData.x_url && (
                                  <Col md={6} className="mb-2">
                                    <a href={expertData.x_url} target="_blank" rel="noopener noreferrer" className="d-flex align-items-center gap-2">
                                      <Twitter size={16} />
                                      <span>X (Twitter)</span>
                                      <ExternalLink size={14} />
                                    </a>
                                  </Col>
                                )}
                                {expertData.instagram_url && (
                                  <Col md={6} className="mb-2">
                                    <a href={expertData.instagram_url} target="_blank" rel="noopener noreferrer" className="d-flex align-items-center gap-2">
                                      <Instagram size={16} />
                                      <span>Instagram</span>
                                      <ExternalLink size={14} />
                                    </a>
                                  </Col>
                                )}
                                {expertData.youtube_url && (
                                  <Col md={6} className="mb-2">
                                    <a href={expertData.youtube_url} target="_blank" rel="noopener noreferrer" className="d-flex align-items-center gap-2">
                                      <Youtube size={16} />
                                      <span>YouTube</span>
                                      <ExternalLink size={14} />
                                    </a>
                                  </Col>
                                )}
                                {expertData.professional_blog && (
                                  <Col md={6} className="mb-2">
                                    <a href={expertData.professional_blog} target="_blank" rel="noopener noreferrer" className="d-flex align-items-center gap-2">
                                      <BookOpen size={16} />
                                      <span>Professional Blog</span>
                                      <ExternalLink size={14} />
                                    </a>
                                  </Col>
                                )}
                                {expertData.portfolio_url && (
                                  <Col md={6} className="mb-2">
                                    <a href={expertData.portfolio_url} target="_blank" rel="noopener noreferrer" className="d-flex align-items-center gap-2">
                                      <Briefcase size={16} />
                                      <span>Portfolio</span>
                                      <ExternalLink size={14} />
                                    </a>
                                  </Col>
                                )}
                              </Row>
                            </div>
                          )}

                          {/* Pricing & Packages */}
                          <div className="mb-4">
                            <h5 className="mb-3 d-flex align-items-center gap-2">
                              <DollarSign size={20} />
                              Pricing & Packages
                            </h5>
                            <Row>
                              {selectedExpertDetails.price && (
                                <Col md={12} className="mb-3">
                                  <strong>Price Range:</strong>
                                  <div className="mt-1">
                                    <Badge color="info" style={{ fontSize: '14px', padding: '6px 12px' }}>
                                      {selectedExpertDetails.price}
                                    </Badge>
                                  </div>
                                </Col>
                              )}
                              {selectedExpertDetails.allpacks && selectedExpertDetails.allpacks.length > 0 && (
                                <Col md={12} className="mb-2">
                                  <strong>Available Packages:</strong>
                                  <div className="mt-2">
                                    {selectedExpertDetails.allpacks.map((pack: any, index: number) => (
                                      <div key={index} className="mb-2 p-3 border rounded-3" style={{ background: '#f8f9fa' }}>
                                        <div className="d-flex align-items-center gap-2 mb-1">
                                          <DollarSign size={16} style={{ color: '#1976d2' }} />
                                          <span className="font-size-15 text-dark fw-medium">${pack.price}</span>
                                          <span className="text-muted">-</span>
                                          <Clock size={16} style={{ color: '#1976d2' }} />
                                          <span className="font-size-15 text-dark fw-medium">{pack.session_mins} Minutes</span>
                                        </div>
                                        {pack.description && (
                                          <div className="font-size-13 text-muted mt-1">{pack.description}</div>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                </Col>
                              )}
                            </Row>
                          </div>

                          {/* Cancellation Policy */}
                          {selectedExpertDetails.policy_time && (
                            <div className="mb-4">
                              <h5 className="mb-3 d-flex align-items-center gap-2">
                                <Shield size={20} />
                                Cancellation Policy
                              </h5>
                              <Row>
                                <Col md={12} className="mb-2">
                                  <p className="text-muted">
                                    You can cancel this booking and receive a full refund up to <strong>{selectedExpertDetails.policy_time} hours</strong> before the event.
                                  </p>
                                </Col>
                              </Row>
                            </div>
                          )}

                          {/* Availability */}
                          {selectedExpertDetails.bookingavails && Object.keys(selectedExpertDetails.bookingavails).length > 0 && (
                            <div className="mb-4">
                              <h5 className="mb-3 d-flex align-items-center gap-2">
                                <Calendar size={20} />
                                Availability
                              </h5>
                              <Row>
                                <Col md={12} className="mb-2">
                                  <div className="text-muted">
                                    Available for booking on <strong>{Object.keys(selectedExpertDetails.bookingavails).length}</strong> date(s)
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          )}

                          {/* Book Now Button */}
                          {localStorage.getItem('userole_') == "cst" && (
                            <div className="d-flex justify-content-end mt-4">
                              <Button
                                color="primary"
                                className="btn btn-primary"
                                onClick={() => {
                                  toggleExpertDetails();
                                  booknowform(selectedExpertDetails);
                                }}
                              >
                                <i className="bx bxs-calendar-plus font-size-16 align-middle me-2"></i>Book Now
                              </Button>
                            </div>
                          )}
                        </div>
                      );
                    })()}
                  </ModalBody>
                </Modal>
              </Card>)}
          </Col>
        </Row>

      </div>
    </React.Fragment>
  );
}

export default Explist;